import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=c15b7bf6"
import script from "./Toolbox.vue?vue&type=script&lang=js"
export * from "./Toolbox.vue?vue&type=script&lang=js"
import style0 from "./Toolbox.vue?vue&type=style&index=0&id=c15b7bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports